const ACCESS_TOKEN_KEY: string = 'access_token';
const TIME_ACCESS_TOKEN_KEY: number = 60000;
const REFRESH_TOKEN_KEY: string = 'refresh_token';
const TIME_DURATION: number = 5000;

export const INFINITY = Number.POSITIVE_INFINITY;

export { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, TIME_ACCESS_TOKEN_KEY, TIME_DURATION };

export const SUPPORTED_IMAGE = ['image/jpeg', 'image/png', 'image/webp'];

export const MONTHS = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const MAX_DATE = new Date(2101, 0, 1);
